import { Grid, SxProps, Theme, Typography } from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { useContext } from "react";
import { LayoutsConfig, MainContext } from "../../context/MainContextProvider";

type AccordionHeaderProps = {
  title: string;
  showDetails: boolean;
  toggleDetails: () => void;
  typographySx?: SxProps<Theme>;
  iconSx?: SxProps<Theme>;
  children?: React.ReactNode;
  disabled?: boolean;
};

export function AccordionHeader({
  title,
  showDetails,
  toggleDetails,
  typographySx,
  iconSx,
  children,
  disabled,
}: AccordionHeaderProps) {
  const { layout, theme } = useContext(MainContext)

  return (
    <Grid
      item
      xs={12}
      sx={{
        padding: "4px",
        display: "flex",
      }}
      onClick={disabled ? () => { } : toggleDetails}
    >
      <Grid sx={{ display: "flex", flexDirection: "row" }} item xs={9}>
        <Typography
          sx={{
            ...typographySx,
            color: disabled ? "rgba(217, 217, 217, 0.5)" : layout == LayoutsConfig.LayoutOne ? "#FFF" : theme.primaryTextColor,
          }}
        >
          {title}
        </Typography>
        {children}
      </Grid>
      <Grid sx={{ justifyContent: "flex-end", display: "flex", alignItems: "center" }} item xs={3}>
        <KeyboardArrowRightIcon
          sx={{
            ...iconSx,
            marginRight: "10px",
            height: "24px",
            width: "24px",
            cursor: "pointer",
            transform: showDetails ? "rotate(90deg)" : "rotate(0deg)",
            transition: "transform 0.1s ease-in-out",
            color: disabled ? "rgba(217, 217, 217, 0.5)" : layout == LayoutsConfig.LayoutOne ? "#FFF" : theme.primaryTextColor,
          }}
        />
      </Grid>
    </Grid>
  );
}
